import { useState } from "react";
import { titleCaseHeadline } from "../utils/titleCase";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { EDITORS_PICKS, getStoryById, STORIES } from "../data/stories";
import Reveal from "./Reveal";

export const EditorsPicks = () => {
  const [count, setCount] = useState(6);
  const preferred = EDITORS_PICKS.map(p => getStoryById(p.id)).filter(Boolean);
  const allPicks = [...new Map([...preferred, ...STORIES].map(story => [story.id, story])).values()];
  const picks = allPicks.slice(0, count).map(story => ({ id: story.id, story, note: story.excerpt }));

  return (
    <section data-testid="editors-picks" className="bg-[var(--bg)]">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 py-14 sm:py-16">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6 border-t-2 border-[var(--divider)] pt-8">
            <div>
              <h2 className="font-display text-3xl sm:text-4xl font-semibold">
                More from The Standard
              </h2>
            </div>
            <span className="hidden sm:flex items-center gap-2 text-[10px] font-extrabold uppercase tracking-[0.2em] text-[var(--faint)]">
              Latest coverage
            </span>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
          {picks.map((pick, i) => (
            <Reveal key={pick.id} delay={i * 0.08} className="h-full">
              <Link
                to={`/${pick.id}`}
                data-testid={`editors-pick-${pick.id}`}
                className="group flex h-full flex-col"
              >
                <div className="img-frame overflow-hidden aspect-[16/10] bg-[var(--card-muted)]">
                  <img
                    src={pick.story.img}
                    alt={pick.story.imgAlt || pick.story.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="mt-5 flex items-center justify-between gap-3">
                  <span className="flex items-baseline gap-3">
                    <span className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-[var(--accent)]">
                      {pick.story.kicker || "The Standard"}
                    </span>
                  </span>
                  <span className="text-[11px] text-[var(--faint)] whitespace-nowrap">
                    {pick.story.date}
                  </span>
                </div>
                <h3 className="mt-2 font-display text-[1.35rem] leading-snug line-clamp-2 font-semibold group-hover:text-[var(--accent)] transition-colors duration-300">
                  {titleCaseHeadline(pick.story.title)}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed line-clamp-2 text-[var(--muted)]">
                  {pick.note}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
        {count < allPicks.length && <div className="mt-10 text-center"><button type="button" onClick={() => setCount(value => value + 6)} className="rounded-[5px] bg-[#cf0a0a] hover:bg-black text-white px-8 py-3 text-[12px] font-bold uppercase tracking-[0.16em] cursor-pointer transition-colors">Load More</button></div>}
      </div>
    </section>
  );
};

export default EditorsPicks;
